import React from 'react';
import { array, string, func, bool } from 'prop-types';

import { EMPTY_IMAGE_BASE64 } from '../../constants'; // 1px placeholder

const propTypes = {
  sources: array,
  src: string,
  alt: string,
  className: string,
  onLoad: func,
  lazy: bool,
  fetchPriority: bool,
};

const Picture = ({
  src = EMPTY_IMAGE_BASE64,
  className = null,
  sources = null,
  alt = null,
  onLoad = null,
  lazy = true,
  fetchPriority = false,
  ...rest
}) => {
  return (
    <picture className={className}>
      {sources &&
        sources.map((source, index) => <source key={index} {...source} />)}
      <img
        loading={lazy ? 'lazy' : 'eager'}
        alt={alt}
        src={src} {...rest}
        fetchPriority={fetchPriority ? 'high' : 'auto'}
      />
    </picture>
  );
}

Picture.propTypes = propTypes;

export default Picture;
